import {CircularProgress, Flex} from "@chakra-ui/react";
import React from "react";
export default function LoadingSpinner () {
    return(
        <Flex h={'100vh'} w={'full'} align={'center'} justifyContent={'center'}>
            <CircularProgress isIndeterminate thickness={6} color='teal.300' value={30} size='120px' />
        </Flex>
    )
}
